import { render, staticRenderFns } from "./ModalActionMultipleRows.vue?vue&type=template&id=54c58ba6"
import script from "./ModalActionMultipleRows.vue?vue&type=script&lang=js"
export * from "./ModalActionMultipleRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports